import React from 'react'
import VisibleComponent from '../../shared/VisibleComponent'

const PolitiqueCookies = () => {
  return (
    <div className="content">
      <VisibleComponent>
        <div className="elements-group">
          <h2>Politique de cookies</h2>
          <p>Ce site n'utilise pas de cookies</p>
        </div>
      </VisibleComponent>
    </div>
  )
}

export default PolitiqueCookies
